export const i = 0;

// export const contractAddress = "TAE21Qxf7QhN663YrMxFp5d74DQgrFeRgs";

export const contractAddress = "TVp1v9DvD64HcjG8cmLj9PBCDLcgScLZg3";
export const refDefaultAddress = "TBuSYgy3JVGwvzhy4EoRmj8dRtaV8Q4xBe";